class PagePopUpBtn {
    constructor(btn) {
      this.btn = btn;
      this.pageUrl = this.btn.getAttribute("data-page-url");
      this.init();
    }
  
    init() {
      if (this.pageUrl) {
        this.openPopup();
      } else {
        console.error("Missing data-page-url on PagePopUpBtn.");
      }
    }
  
    openPopup() {
      const popupOverlay = document.createElement("section");
      popupOverlay.classList.add("page-popup--container");
      popupOverlay.setAttribute("aria-hidden", "true");
      popupOverlay.innerHTML = `
        <div class="inner--popup">
          <button class="close-popup--btn">
            <div class="close-icon">X</div>
            <div class="screen-reader-text">Close Page Popup Button</div>
          </button>
          <div class="page-popup-container">
            <iframe src="${this.pageUrl}" frameborder="0" width="100%" height="100%" allowfullscreen></iframe>
          </div>
        </div>
      `;
  
      document.body.appendChild(popupOverlay);
      this.addCloseEvent();
    }
  
    addCloseEvent() {
      const closeBtn = document.querySelector(".page-popup--container .close-popup--btn");
      if (closeBtn) {
        closeBtn.addEventListener("click", () => {
          document.querySelector(".page-popup--container").remove();
        });
      }
    }
  }  